import React, { useContext, useEffect, useState } from "react";
import { Modal, Button, TextInput, Label } from "flowbite-react";
import Button_submit from "../components/Button_submit";
import axios from "axios";
import GlobalContext from "../connections/GlobalContext";
import Swal from "sweetalert2";
import Head_data from "../components/Head_data";
import DataTable from "react-data-table-component";
import Select from "react-select";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import engineGif from "../image/engine.gif";

const Staff = ({ isSidebarOpen }) => {
  const [open, setOpen] = useState(false);
  const { globalValue } = useContext(GlobalContext);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [nameError, setNameError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [staffs, setStaffs] = useState([]);
  const [mode, setMode] = useState("");
  const [flag_branch, setFlag_branch] = useState([
    sessionStorage.getItem("branch"),
  ]);
  const [flag_berror, setFlag_berror] = useState("");
  const [role, setRole] = useState("");
  const [roleError, setRoleError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [loading, setLoading] = useState(false);

  const [email_id, setEmail_id] = useState("");
  const [email_id_error, setEmail_id_error] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [filtered, setFiltered] = useState(staffs);

  useEffect(() => {
    const filteredData = staffs.filter((branch) =>
      branch[2].toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFiltered(filteredData);
  }, [searchTerm, staffs]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "name") {
      const validName = value.replace(/[^a-zA-Z\s]/g, "");
      setName(validName);
    }
    if (name === "mobile") setMobile(value);
    if (name === "address") setAddress(value);
    if (name === "password") setPassword(value);
    if (name === "confirmPassword") setConfirmPassword(value);
    if (name === "role") setRole(value);
    if (name === "branch") setFlag_branch(value);
    if (name === "email_id") {
      setEmail_id(value);
    }

    validate(name, value);
  };

  const validate = (fieldName, value) => {
    switch (fieldName) {
      case "name":
        if (!value) setNameError("Staff name is required.");
        else setNameError("");
        break;
      case "mobile":
        if (!/^\d{10}$/.test(value))
          setMobileError("Mobile number must be 10 digits.");
        else setMobileError("");
        break;
      case "address":
        if (!value) setAddressError("Address is required.");
        else setAddressError("");
        break;
      case "password":
        if (value.length < 6)
          setPasswordError("Password must be at least 6 characters.");
        else setPasswordError("");
        break;
      case "confirmPassword":
        if (value !== password)
          setConfirmPasswordError("Passwords do not match.");
        else setConfirmPasswordError("");
        break;
      case "role":
        if (!value) setRoleError("Role is required.");
        else setRoleError("");
        break;
      case "email_id":
        if (!value) setEmail_id_error("Email Id is required.");
        else setEmail_id_error("");
        break;
      default:
        break;
    }
  };

  const [username, setUsername] = useState("");
  const handleSubmit = async () => {
    if (
      !name ||
      !mobile ||
      !address ||
      !password ||
      password !== confirmPassword ||
      !role ||
      !flag_branch ||
      !email_id
    ) {
      if (!name) setNameError("Staff name is required.");
      if (!mobile) setMobileError("Mobile number is required.");
      if (!address) setAddressError("Address is required.");
      if (!password) setPasswordError("Password is required.");
      if (!confirmPassword)
        setConfirmPasswordError("Conform Password is required.");
      if (password !== confirmPassword)
        setConfirmPasswordError("Passwords do not match.");
      if (!role) setRoleError("Role is required.");
      if (!flag_branch) setFlag_berror("branch is required");
      if (!email_id) setEmail_id_error("Email_id is required");

      return;
    }
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailPattern.test(email_id)) {
      setEmail_id_error("Invalid email format");
      return;
    } else {
      setEmail_id_error("dsds");
    }
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/staff_submit`,
        {
          name,
          mobile,
          address,
          password,
          confirmPassword,
          role,
          email_id,
          flag_branch,
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );
      if (response.data === "success") {
        fetchData();
        setName("");
        setMobile("");
        setAddress("");
        setPassword("");
        setConfirmPassword("");
        setNameError("");
        setMobileError("");
        setAddressError("");
        setConfirmPasswordError("");
        setPasswordError("");
        setRole("");
        setRoleError("");
        setFlag_berror("");
        setFlag_branch("");

        setEmail_id("");
        setEmail_id_error("");
        Swal.fire({
          icon: "success",
          title: "Staff Added Successfully",
        });
      }
      setOpen(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async () => {
    if (
      !name ||
      !mobile ||
      !address ||
      !password ||
      !password ||
      !role ||
      !email_id
    ) {
      if (!name) setNameError("Staff name is required.");
      if (!mobile) setMobileError("Mobile number is required.");
      if (!address) setAddressError("Address is required.");
      if (!password) setPasswordError("Password is required.");
      if (password !== confirmPassword)
        setConfirmPasswordError("Passwords do not match.");
      if (!role) setRoleError("Role is required.");
      if (!email_id) setEmail_id_error("Email_id is required");
      return;
    }
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailPattern.test(email_id)) {
      setEmail_id_error("Invalid email format");
      return;
    } else {
      setEmail_id_error("");
    }
    setLoading(true);
    try {
      console.log(flag_branch + "crommc");
      const response = await axios.post(
        `${globalValue}/staff_edit`,
        {
          name,
          mobile,
          address,
          password,
          username,
          role,
          email_id,
          flag_branch,
          mobile_no: sessionStorage.getItem("name"),
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );
      if (response.data === "success") {
        fetchData();
        setName("");
        setMobile("");
        setAddress("");
        setPassword("");
        setConfirmPassword("");
        setNameError("");
        setMobileError("");
        setAddressError("");
        setConfirmPasswordError("");
        setPasswordError("");
        setRole("");
        setRoleError("");

        setEmail_id("");
        setEmail_id_error("");

        Swal.fire({
          icon: "success",
          title: "Staff Edited Successfully",
        });
      }
      setOpen(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: "white",
        width: "100%",
        border: "solid 1px rgb(226, 232, 240)",
      },
    },
    headCells: {
      style: {
        backgroundColor: "rgb(226, 232, 240)",
        color: "black",
        fontWeight: "bold",
      },
    },
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/staffs`, {
        params: {
          data: sessionStorage.getItem("branch"),
          position: "",
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });
      setStaffs(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const [branches, setBranches] = useState([]);
  const fetchData1 = () => {
    fetch(globalValue + "/branches", {
      method: "GET",
      headers: {
        "x-access-token": sessionStorage.getItem("token"),
      },
    })
      .then((res) => res.json())
      .then((dat) => {
        setBranches(dat);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const options = branches.map((data) => ({
    value: data[1],
    label: data[2],
  }));
  useEffect(() => {
    fetchData();
    fetchData1();

    if (sessionStorage.getItem("position") !== "superadmin") {
      console.log(sessionStorage.getItem("branch"));
      setFlag_branch(sessionStorage.getItem("branch"));
    }
  }, []);

  const handleDelete = async (data) => {
    const result = await Swal.fire({
      title: "Are you sure ?",
      text: " Do you want to delete staff,This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      setLoading(true);
      try {
        const response = await axios.post(
          `${globalValue}/staff_delete`,
          {
            data,
          },
          {
            headers: {
              "x-access-token": sessionStorage.getItem("token"),
            },
          }
        );
        if (response.data === "success") {
          fetchData();

          Swal.fire({
            icon: "success",
            title: "Staff Deleted Successfully",
          });
        }
      } catch (error) {
        console.error("Error deleting staff:", error);
        Swal.fire("Error!", "Something went wrong.", "error");
      } finally {
        setLoading(false);
      }
    }
  };
  const [show2, setShow2] = useState(false);
  const [known_data, setKnown_data] = useState("");
  const know_details = async (mobile_no) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/know_details`,
        {
          mobile_no,
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );
      setKnown_data(response.data);
    } catch (error) {
      console.error("Error deleting staff:", error);
      Swal.fire("Error!", "Something went wrong.", "error");
    } finally {
      setLoading(false);
    }
  };
  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "70px",
    },
    {
      name: "Staff Name",
      selector: (row) => row[2],
      sortable: true,
    },

    {
      name: "Mobile/whatsapp no",
      selector: (row) => row[3],
      sortable: true,
    },
    {
      name: "Email_id",
      selector: (row) => row[8],
      sortable: true,
    },
    {
      name: "Address",
      selector: (row) => row[4],
      sortable: true,
    },
    {
      name: "Position",
      selector: (row) => row[6],
      sortable: true,
    },

    {
      name: "Actions",
      width: "140px",
      center: true,
      cell: (row) =>
        sessionStorage.getItem("name") === row[1] ||
        row[6][0] === "staff" ||
        sessionStorage.getItem("position") === "superadmin" ? (
          <div className="flex space-x-3">
            <button
              onClick={() => {
                setShow2(true);
                know_details(row[3]);
              }}
              className="p-2 text-white bg-blue-600 rounded-md hover:bg-blue-700"
            >
              <i className="fa fa-eye"></i>
            </button>

            <button
              className="p-2 text-white border bg-blue-700 hover:bg-blue-800 rounded-md shadow-xl"
              onClick={() => {
                setName(row[2]);
                setMobile(row[3]);
                setAddress(row[4]);
                setPassword(row[5]);
                setUsername(row[1]);
                setRole(row[6]);
                setEmail_id(row[8]);
                setMode("edit");
                setOpen(true);
                setFlag_berror("");
                setFlag_branch(row[7]);
                setNameError("");
                setMobileError("");
                setAddressError("");
                setConfirmPasswordError("");
                setPasswordError("");
                setRoleError("");
              }}
            >
              <i className="fa fa-edit"></i>
            </button>
            <button
              className="p-2 text-white border bg-yellow-500 hover:bg-yellow-800 rounded-md shadow-xl"
              onClick={() => {
                handleDelete(row[1]);
              }}
            >
              <i className="fa fa-trash"></i>
            </button>
          </div>
        ) : null,
    },
  ];

  const [roleOptions, setRoleOptions] = React.useState([]);

  React.useEffect(() => {
    const fetchRoles = async () => {
      try {
        const res = await axios.get(`${globalValue}/roles_display`, {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        });
        setRoleOptions(res.data);
      } catch (error) {
        console.error("Error fetching role options:", error);
      }
    };

    fetchRoles();
  }, []);

  return (
    <>
      <div
        className={`md:ml-[250px] w-full md:w-[calc(100%-250px)]  mt-16 h-[92vh] flex justify-center items-center box-border`}
      >
        {loading && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
            <img src={engineGif} alt="Loading..." className="w-24 h-24" />
          </div>
        )}
        <div className="w-[95%] md:w-[98%] h-[95%] bg-white px-4 py-2 rounded-xl shadow-xl overflow-auto">
          <div className="w-full flex justify-between text-gray-600">
            <Head_data data="Manage Staff" font="" size="3xl"></Head_data>
            <button
              onClick={() => {
                setMode("add");
                setOpen(true);
                setName("");
                setMobile("");
                setAddress("");
                setPassword("");
                setConfirmPassword("");
                setNameError("");
                setMobileError("");
                setAddressError("");
                setConfirmPasswordError("");
                setPasswordError("");
                setRole("");
                setRoleError("");
                setFlag_berror("");
                setEmail_id("");
                setEmail_id_error("");
                setFlag_branch(sessionStorage.getItem("branch"));
              }}
              className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700 md:mt-2"
            >
              Add Staff
            </button>
          </div>

          <input
            type="text"
            placeholder="Search by staff name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full md:w-1/3 px-4 my-2 py-2 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
          />

          <div className="py-6 md:px-4 ">
            <DataTable
              columns={columns}
              data={filtered}
              pagination
              highlightOnHover
              pointerOnHover
              customStyles={customStyles}
            />
          </div>
        </div>
      </div>
      <Modal show={show2} onClose={() => setShow2(false)}>
        <Modal.Header className="flowbite-modal-h">Staff Details</Modal.Header>
        <Modal.Body className="flowbite-modal-h">
          <p className="text-lg text-gray-600">{known_data}</p>
        </Modal.Body>
      </Modal>

      <Modal show={open} onClose={() => setOpen(false)}>
        <Modal.Header className="flowbite-modal-h">
          {mode === "add" ? "ADD" : "Edit"} Staff
        </Modal.Header>
        <Modal.Body className="flowbite-modal-h">
          <form className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <Label htmlFor="name" value="Staff Name" />
                <TextInput
                  id="name"
                  name="name"
                  placeholder="staff name"
                  value={name}
                  onChange={handleInputChange}
                  color={nameError ? "failure" : "white"}
                  required
                />
                {nameError && (
                  <p className="text-sm text-red-600">{nameError}</p>
                )}
              </div>
              <div>
                <Label htmlFor="mobile" value="Mobile/whatsapp No" />
                <TextInput
                  id="mobile"
                  name="mobile"
                  min="0"
                  placeholder="mobile number"
                  value={mobile}
                  onChange={handleInputChange}
                  color={mobileError ? "failure" : "white"}
                  required
                />
                {mobileError && (
                  <p className="text-sm text-red-600">{mobileError}</p>
                )}
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <Label htmlFor="address" value="Address" />
                <textarea
                  id="address"
                  name="address"
                  placeholder="address"
                  value={address}
                  onChange={handleInputChange}
                  required
                  className="w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                ></textarea>
                {addressError && (
                  <p className="text-sm text-red-600">{addressError}</p>
                )}
              </div>
              <div>
                <Label htmlFor="email_id" value="Email_id" />
                <input
                  id="email_id"
                  name="email_id"
                  placeholder="eg.abc@gmail.com"
                  value={email_id}
                  onChange={handleInputChange}
                  required
                  className="w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                ></input>
                {email_id_error && (
                  <p className="text-sm text-red-600">{email_id_error}</p>
                )}
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="relative">
                <Label htmlFor="password" value="Password" />
                <TextInput
                  id="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="password"
                  value={password}
                  onChange={handleInputChange}
                  required
                  color={passwordError ? "failure" : "white"}
                />
                <button
                  type="button"
                  className="absolute right-3 top-9 text-gray-500"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
                {passwordError && (
                  <p className="text-sm text-red-600">{passwordError}</p>
                )}
              </div>

              {mode === "add" && (
                <div className="relative">
                  <Label htmlFor="confirmPassword" value="Confirm Password" />
                  <TextInput
                    id="confirmPassword"
                    name="confirmPassword"
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm password"
                    value={confirmPassword}
                    onChange={handleInputChange}
                    required
                    color={confirmPasswordError ? "failure" : "white"}
                  />
                  <button
                    type="button"
                    className="absolute right-3 top-9 text-gray-500"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                  {confirmPasswordError && (
                    <p className="text-sm text-red-600">
                      {confirmPasswordError}
                    </p>
                  )}
                </div>
              )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label
                  htmlFor="branch"
                  className="block text-sm font-medium text-gray-700"
                >
                  Role
                </label>
                <select
                  id="role"
                  name="role"
                  value={role}
                  onChange={handleInputChange}
                  className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:ring focus:ring-blue-500 ${
                    roleError ? "border-red-500" : "border-gray-300"
                  }`}
                  required
                >
                  <option value="" disabled>
                    Select Role
                  </option>
                  {sessionStorage.getItem("position") === "superadmin" ? (
                    <option value="admin">Admin</option>
                  ) : null}
                  <option value="staff">Staff</option>
                  <option value="mechanic">Mechanic</option>
                  {roleOptions.map((roleItem) => (
                    <option
                      key={roleItem.id}
                      value={roleItem.category_name.toLowerCase()}
                    >
                      {roleItem.category_name}
                    </option>
                  ))}
                </select>
                {roleError && (
                  <p className="text-sm text-red-600">{roleError}</p>
                )}
              </div>
              <div>
                <label
                  htmlFor="branch"
                  className="block text-sm font-medium text-gray-700"
                >
                  Branch
                </label>
                <Select
                  id="branch"
                  name="branch"
                  options={options}
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                  maxMenuHeight={130}
                  value={options.filter((option) =>
                    flag_branch.includes(option.value)
                  )}
                  onChange={(selectedOptions) => {
                    setFlag_branch(
                      selectedOptions
                        ? selectedOptions.map((option) => option.value)
                        : []
                    );
                  }}
                  isMulti
                  isDisabled={
                    sessionStorage.getItem("position") !== "superadmin"
                  }
                  placeholder="Select Branch(es)"
                  className={`block w-full ${
                    flag_berror ? "border-red-500" : "border-gray-300"
                  }`}
                />
                {flag_berror && (
                  <p className="text-sm text-red-600">{flag_berror}</p>
                )}
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="flowbite-modal-h">
          <Button_submit
            onClick={() => {
              mode === "add" ? handleSubmit() : handleEdit();
            }}
            data={`${mode === "add" ? "Submit" : "Update"}`}
            type="submit"
            aditional="ms-auto"
          />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Staff;
